var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3952 0.863647H1.62752C1.38273 0.863647 1.14797 0.961191 0.974879 1.13482C0.801786 1.30845 0.704544 1.54394 0.704544 1.78949V4.18743C0.704544 4.67165 0.901139 5.14753 1.24264 5.49009L6.24242 10.5054V17.5288C6.2426 17.6866 6.28292 17.8417 6.35955 17.9794C6.43618 18.1172 6.54659 18.233 6.68032 18.316C6.81406 18.3989 6.9667 18.4463 7.12378 18.4536C7.28086 18.4608 7.4372 18.4278 7.57797 18.3575L11.2699 16.5058C11.5828 16.3484 11.7803 16.0281 11.7803 15.6772V10.5054L16.7801 5.49009C17.1216 5.14753 17.3182 4.67165 17.3182 4.18743V1.78949C17.3182 1.54394 17.2209 1.30845 17.0478 1.13482C16.8748 0.961191 16.64 0.863647 16.3952 0.863647ZM10.2048 9.46752C10.1189 9.55335 10.0508 9.65537 10.0044 9.76771C9.95797 9.88005 9.93417 10.0005 9.93434 10.1221V15.105L8.08838 16.0308V10.1221C8.08856 10.0005 8.06475 9.88005 8.01834 9.76771C7.97193 9.65537 7.90383 9.55335 7.81795 9.46752L2.5505 4.18743V2.71534H15.4731L15.475 4.18095L10.2048 9.46752Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/media/IconFilter.50f263fb8c0e3711b14bc9792c5cf5d0.svg";
export { ForwardRef as ReactComponent };